import i18n from '@/i18n/i18n'

export default {
  generalKey: state => key => state.generalEnums.find(e => e.key === key).value,
  selectOptions: state => (key, locale) => {
    if (state.generalEnums.length === 0) return []
    const values = state.generalEnums.find(e => e.key === key).value
    const options = []
    if (values) {
      for (const r in values) {
        options.push({
          label: i18n.t(`${locale}.${values[r]}`),
          value: values[r]
        })
      }
    }
    return options
  }
}
